export default {"src":"/_next/static/media/phone-cracked.2147f866.svg","height":77,"width":66};